/**
 * Sürüm şeridi (şartname 4, 9): her çekim yeni sürüm. Yatay kayan kap büyümeye kapalı; hepsi "Tüm sürümler" ile açılır.
 * Eski sürüm salt okunur açılır.
 */
import { useState } from 'react';
import { HIZLI_METIN as M } from '../metin/hizliTeklif';
import { gunAyKisa, saatYaz } from './mantik';
import type { SurumOzeti } from './tipler';

export function SurumSeridi({ surumler, aktif, ac, taslagaDon, hata }: { surumler: readonly SurumOzeti[]; aktif: number | null; ac: (s: SurumOzeti) => void; taslagaDon: () => void; hata: string | null }) {
  const [hepsi, setHepsi] = useState(false);
  const sirali = [...surumler].sort((a, b) => a.surumNo - b.surumNo);
  const gorunen = hepsi ? sirali : sirali.slice(-4);
  const chip = (s: SurumOzeti) => (
    <button
      key={s.id}
      type="button"
      className="ht-surum-chip"
      aria-pressed={aktif === s.surumNo}
      onClick={() => ac(s)}
      data-testid={`ht-surum-${s.surumNo}`}
    >
      <b>v{s.surumNo}</b>
      <span>{gunAyKisa(s.kayitZamani)} {saatYaz(s.kayitZamani)}, {s.secenekSayisi > 0 ? M.surumSecenek(s.secenekSayisi) : M.surumOtel(s.otelSayisi)}</span>
    </button>
  );
  return (
    <section className="ht-kart ht-surumler" aria-labelledby="ht-surum-baslik" data-testid="ht-surumler">
      <h2 id="ht-surum-baslik" className="ht-surum-baslik">{M.surumlerBaslik}</h2>
      {sirali.length === 0 ? <span className="ht-ipucu">{hata ?? M.surumYok}</span> : <div className="ht-surum-kayan">{gorunen.map(chip)}</div>}
      {sirali.length > 4 ? (
        <button type="button" className="ht-btn" aria-expanded={hepsi} onClick={() => setHepsi((v) => !v)}>{M.tumSurumler(sirali.length)}</button>
      ) : null}
      {aktif !== null ? <button type="button" className="ht-btn ht-btn-p" onClick={taslagaDon} data-testid="ht-surum-don">{M.surumDon}</button> : <span className="ht-ipucu">{M.surumSalt}</span>}
    </section>
  );
}
